import React, { useState } from "react";
import { FormControl, Radio, RadioGroup } from "@mui/material";
import { IOptionGeneric } from "../../../interface";
import MyFormControlWhiteLabel from "../../../../components/MyFormControlWhiteLabel/MyFormControlWhiteLabel";

interface TimeSlotGridProps {
  slots: IOptionGeneric[];
  selectedValue: string | null;
  onSelect: (slot: IOptionGeneric) => void;
  columns?: 2 | 3;
  maxVisible?: number;
  gridId: string;
}

const formControlStyles = {
  "textTransform": "uppercase",
  "fontFamily": "geograph-regular",
  "p": 0,
  "height": "35px",
  "& .MuiTypography-root": { lineHeight: "16px" },
  "width": "100%",
  "textAlign": "center",
};

export const TimeSlotGrid = ({
  slots,
  selectedValue,
  onSelect,
  columns = 2,
  maxVisible,
  gridId,
}: TimeSlotGridProps) => {
  const [showAll, setShowAll] = useState(!maxVisible);
  const visibleSlots = showAll ? slots : slots.slice(0, maxVisible);
  const hiddenCount = slots.length - (maxVisible ?? slots.length);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const slot = slots.find((s) => s.value === e.target.value);

    if (slot) onSelect(slot);
  };

  if (!slots.length) return null;

  return (
    <FormControl sx={{ display: "grid", width: "100%" }}>
      <RadioGroup
        value={selectedValue || ""}
        name={`urgent-visit-slots-${gridId}`}
        className="!grid"
        onChange={handleChange}
      >
        <div className={`grid gap-2 ${columns === 3 ? "grid-cols-3" : "grid-cols-2"}`}>
          {visibleSlots.map((slot) => (
            <MyFormControlWhiteLabel
              sx={formControlStyles}
              key={slot.value}
              value={slot.value}
              disabled={slot.disabled}
              control={<Radio />}
              label={slot.label}
              checked={slot.value === selectedValue}
              customStyle={true}
            />
          ))}
        </div>
      </RadioGroup>
      {!showAll && hiddenCount > 0 && (
        <button
          type="button"
          className="w-full mt-2 py-2 text-sm font-medium text-light-black border border-taupe-50 rounded-lg
            hover:bg-taupe-15 transition-colors cursor-pointer"
          onClick={() => setShowAll(true)}
        >
          {`View ${hiddenCount} More Slots`}
        </button>
      )}
    </FormControl>
  );
};
